module.exports = __webpack_public_path__ + "static/ey-3-sq-9c66e87f224fcd6a76176c9866b5f456.png";